const NAME = "DIGITAL_WAREHOUSE_FILE_TYPES";

export default NAME;
